import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {FormControl} from '@angular/forms';

import {RequestParameters} from '../../models/request-parameters/parameter.model';
import {OrganizationService} from '../../../organization/organization.service';
import {Organization} from '../../../organization/organization.model';

@Component({
  selector: 'app-organizations-autocomplete',
  templateUrl: './organizations-autocomplete.component.html',
  styleUrls: ['./organizations-autocomplete.component.scss']
})
export class OrganizationsAutocompleteComponent implements OnInit {

  @Input('organizationFormControl') organizationFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onOrganizationSelected: EventEmitter<Organization> = new EventEmitter<Organization>();

  @ViewChild('autoParent')  autoParent: ElementRef;

  organizations: Observable<any> = new Observable<any>();
  organizationLoading: boolean = true;
  organizationParameters: RequestParameters = new RequestParameters();

  constructor(private organizationService: OrganizationService) {
    this.updateOrganization();
  }

  ngOnInit() {
  }

  onSelectOrganization() {
    this.onOrganizationSelected.emit(this.organizationFormControl.value);
  }


  displayOrganization (organization: Organization) {
    if (organization !== null) {
      return organization.name;
    }
  }

  filterOrganizations (filterInput: string = '') {
    if (this.organizationParameters.searchString !== filterInput) {
      this.organizationParameters.searchString = filterInput;
      this.updateOrganization();
    }
  }

  updateOrganization () {
    this.organizationLoading = true;
    this.organizations = this.organizationService.getOrganizations(this.organizationParameters)
      .map(
        (response) => {
          this.organizationLoading = false;
          return response.result;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/organizations-autocomplete/organizations-autocomplete.component.ts